import React from "react";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import BrandHeader from "@/components/BrandHeader";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div
      className="min-h-screen bg-[#F8FAFC] flex flex-col"
      style={{ fontFamily: "Montserrat, sans-serif" }}
      data-testid="contact-root"
    >
      <BrandHeader />

      <main className="flex-1 flex items-start justify-center py-10 sm:py-16 px-4">
        <div className="w-full max-w-3xl">
          <div className="text-center">
            <span className="text-xs font-semibold uppercase tracking-wider text-[#FF8800]">
              Get in touch
            </span>
            <h1 className="mt-2 text-4xl sm:text-5xl font-semibold tracking-tight text-[#001B33]">
              Contact Us
            </h1>
            <div className="mx-auto mt-3 h-1 w-16 bg-[#FF8800] rounded-full" />
            <p className="mt-6 text-base md:text-lg text-slate-600 font-medium max-w-xl mx-auto">
              Questions about going solar? Reach out — we typically respond within 24 hours.
            </p>
          </div>

          <div
            data-testid="contact-card"
            className="mt-10 bg-[#001B33] rounded-2xl p-8 sm:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.12)]"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <a
                data-testid="contact-phone-link"
                href="tel:+16105055200"
                className="group flex items-start gap-4 p-5 rounded-xl border border-white/10 hover:border-[#FF8800] hover:bg-white/5 transition-all"
              >
                <span className="h-12 w-12 rounded-full bg-[#FF8800]/20 group-hover:bg-[#FF8800] flex items-center justify-center flex-shrink-0 transition-colors">
                  <Phone className="h-5 w-5 text-[#FF8800] group-hover:text-white transition-colors" />
                </span>
                <div className="min-w-0">
                  <div className="text-xs font-semibold uppercase tracking-wider text-[#FF8800]">
                    Call us
                  </div>
                  <div className="mt-1 text-lg font-semibold text-white">
                    (610) 505-5200
                  </div>
                  <div className="mt-1 text-xs text-white/60 font-medium">
                    Mon–Fri, 9am–6pm ET
                  </div>
                </div>
              </a>

              <a
                data-testid="contact-email-link"
                href="mailto:solfish1125@gmail.com"
                className="group flex items-start gap-4 p-5 rounded-xl border border-white/10 hover:border-[#FF8800] hover:bg-white/5 transition-all"
              >
                <span className="h-12 w-12 rounded-full bg-[#FF8800]/20 group-hover:bg-[#FF8800] flex items-center justify-center flex-shrink-0 transition-colors">
                  <Mail className="h-5 w-5 text-[#FF8800] group-hover:text-white transition-colors" />
                </span>
                <div className="min-w-0">
                  <div className="text-xs font-semibold uppercase tracking-wider text-[#FF8800]">
                    Email us
                  </div>
                  <div className="mt-1 text-base sm:text-lg font-semibold text-white break-all">
                    solfish1125@gmail.com
                  </div>
                  <div className="mt-1 text-xs text-white/60 font-medium">
                    Replies within 24 hours
                  </div>
                </div>
              </a>
            </div>

            <div className="mt-6 pt-6 border-t border-white/10 flex items-center gap-3 text-white/70 text-sm font-medium">
              <Clock className="h-4 w-4 text-[#FF8800] flex-shrink-0" />
              <span>
                We&apos;ll get back to you within 24 hours with a custom solar estimate.
              </span>
            </div>
          </div>

          <div className="mt-10 text-center">
            <p className="text-sm text-slate-600 font-medium">
              Ready to see your savings?
            </p>
            <Link
              to="/"
              data-testid="contact-to-quiz-btn"
              className="mt-4 inline-flex items-center gap-2 bg-[#FF8800] hover:bg-[#E67A00] text-white font-semibold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition-all active:scale-[0.99]"
            >
              Take the 1-minute quiz
            </Link>
          </div>
        </div>
      </main>

      <Link
        to="/admin/login"
        data-testid="footer-login-link"
        className="fixed bottom-3 left-3 text-[10px] text-slate-400 hover:text-[#FF8800] font-medium tracking-wider uppercase transition-colors opacity-60 hover:opacity-100"
      >
        login
      </Link>
    </div>
  );
}
